import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Directory from "@/pages/Directory";
import ProfessionalDetail from "@/pages/ProfessionalDetail";
import Dashboard from "@/pages/Dashboard";
import Aurora from "@/pages/Aurora";
import Messages from "@/pages/Messages";
import Prescriptions from "@/pages/Prescriptions";
import PreAnamnesis from "@/pages/PreAnamnesis";
import Chart from "@/pages/Chart";
import Admin from "@/pages/Admin";
import SusPortal from "@/pages/SusPortal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";
import "@/App.css";

function Shell() {
  const location = useLocation();
  // Emergent Google Auth callback handling (synchronous during render)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Register />} />
          <Route path="/profissionais" element={<Directory />} />
          <Route path="/profissionais/:id" element={<ProfessionalDetail />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/aurora" element={<ProtectedRoute><Aurora /></ProtectedRoute>} />
          <Route path="/mensagens" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/mensagens/:userId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/prescricoes" element={<ProtectedRoute><Prescriptions /></ProtectedRoute>} />
          <Route path="/pre-anamnese" element={<ProtectedRoute><PreAnamnesis /></ProtectedRoute>} />
          <Route path="/prontuario" element={<ProtectedRoute><Chart /></ProtectedRoute>} />
          <Route path="/prontuario/:patientId" element={<ProtectedRoute><Chart /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/sus/:slug" element={<SusPortal />} />
          <Route path="/pagamento/sucesso" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/pagamento/cancelado" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}
